import ENTITIES from '..';
import { updateRemote } from '../atomic';
import GAME_STRUCT, { GAME_STATUS } from '.';
import { connection } from '../../..';
import { execAfterUserConfirmation } from '../../app/actions';

export function startGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.STATUS_ID]: GAME_STATUS.PLAYING,
  });
}

export function finishGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.STATUS_ID]: GAME_STATUS.FINISHED,
  });
}

export function editGame(store, game) {
  updateRemote(store, ENTITIES.GAME, game);
}

export function deleteGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.HIDDEN]: 1,
  });
}

export function exportFile1(store, data) {
  connection.exportFile1(data);
}

export function exportFile2(store, data) {
  connection.exportFile2(data);
}

export function uploadFile(store, file) {
  connection.uploadFile(file);
}

export function uploadGameForm(store, gameData, onSuccess) {
  execAfterUserConfirmation(store, () => {
    connection.uploadGameForm(gameData, onSuccess);
  });
}

export function getLogs() {
  connection.getLogs();
}

export function sendGamePins(store, game, users) {
  const siteUrl = document.location.href;
  connection.sendGamePins(game[GAME_STRUCT.ID], siteUrl, users);
}

export function autoLogout(store, exerciseId) {
  connection.autoLogout(exerciseId);
}
